import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-graphic-small',
  templateUrl: './ticket-graphic-small.component.html',
  styleUrls: ['./ticket-graphic-small.component.scss'],
})
export class TicketGraphicSmallComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
